import { Component, OnInit, ViewChild } from "@angular/core";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { MatTableDataSource } from "@angular/material/table";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { LmsService } from "../services/lms.service";
import { MasterService } from "../../Shared/app.Masters.Service";

import { MatSort } from "@angular/material/sort";
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
declare var $: any;
@Component({
  selector: "app-payment-info",
  templateUrl: "./payment-info.component.html",
  styleUrls: ["./payment-info.component.scss"],
})
export class PaymentInfoComponent implements OnInit {
  Matchhdata: any[] = [];
MisMatchdata: any[] = [];
displayedColumnsBulkImport: string[] = [];
displayedColumnsNotMatchImport: string[] = [];
dataSourceBulkImport: MatTableDataSource<any>;
dataSourceBulkImport_NotMatch: MatTableDataSource<any>;
showSpinner = false;
progressImport: number = 0;
mode = "indeterminate";
  file: any;
  loading: boolean = false;
  private _MasterService;
uploadedLoanData: any[] = [];
uploadedLoanColumns: string[] = [];
uploadedLoanDataSource = new MatTableDataSource<any>();

uploadedAccountingData: any[] = [];
uploadedAccountingColumns: string[] = [];
uploadedAccountingDataSource = new MatTableDataSource<any>();
  arrayBuffer: any;
  PostBulkProcess: any[] = [];

  currentUser: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  constructor(
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private lmsService: LmsService,
    private MasterService: MasterService
  ) {
    this._MasterService = MasterService;

  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Payment Info");
  }
  public exportAsLoanExcelFile(excelFileName: string): void {
    // var json=[{Date:'',Rec_No:'',Rec_date:'',Loan_No:'',EMI_Amt:'',OD_Amt:'',Other_Amt:''}]
    var json = [
      [
        "Voucher_Day",
        "Voucher_Month",
        "Voucher_Year",
        "Payment_Day",
        "Payment_Month",
        "Payment_Year",
        "Loan_No",
        "HeadId",
        "Amount",
        "Narration",
      ],
    ];
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(json);
    // console.log('worksheet',worksheet);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsloanExcelFile(excelBuffer, excelFileName);
  }
  private saveAsloanExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  // export accounting template
  public exportAsAccountingExcelFile(excelFileName: string): void {
    // var json=[{Date:'',Rec_No:'',Rec_date:'',Loan_No:'',EMI_Amt:'',OD_Amt:'',Other_Amt:''}]
    var json = [
      [
        "Voucher_Day",
        "Voucher_Month",
        "Voucher_Year",
        "Payment_Day",
        "Payment_Month",
        "Payment_Year",
        "AccountId",
        "Amount",
        "Narration",
      ],
    ];
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(json);
    // console.log('worksheet',worksheet);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsAccountingExcelFile(excelBuffer, excelFileName);
  }
  private saveAsAccountingExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }
  public exportAsAccountMasterlistExcelFile(excelFileName: string): void {
    this.lmsService.Get_Account_Master({}).subscribe((res: any) => {
      // Map to only AccountId and Account_Name
      const exportData = (res || []).map((item: any) => ({
        AccountId: item.AccountId,
        Account_Name: item.Account_Name,
      }));

      // Create worksheet and workbook
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
      const workbook: XLSX.WorkBook = {
        Sheets: { data: worksheet },
        SheetNames: ["data"],
      };
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // Save file
      this.saveAsAccountingExcelFile(excelBuffer, excelFileName);
    });
  }

exportAsBranchlistExcelFile(excelFileName: string): void {
  this.lmsService.GetBranches({ Emp_Id: this.currentUser.userId }).subscribe((res: any) => {
    // Map to only BranchId and Branch_Name
    const exportData = (res || []).map((item: any) => ({
      BranchId: item.BranchId,
      Branch_Name: item.Branch_Name
    }));

    // Create worksheet and workbook
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save file
    this.saveAsAccountingExcelFile(excelBuffer, excelFileName);
  });
}

  exportAsHeadlistExcelFile(excelFileName: string): void {
  this._MasterService.ChargesHeadsList().subscribe((res: any) => {
    // Map to only ChagesHeadID and ChagesHead
    const exportData = (res || []).map((item: any) => ({
      ChagesHeadID: item.ChagesHeadID,
      ChagesHead: item.ChagesHead
    }));

    // Create worksheet and workbook
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save file
    this.saveAsAccountingExcelFile(excelBuffer, excelFileName);
  });
}

onLoanFileChange(event: any) {
  this.Matchhdata = [];
  this.MisMatchdata = [];
  this.showSpinner = false;
  this.progressImport = 0;
  this.mode = "determinate";

  const target: DataTransfer = <DataTransfer>(event.target);
  if (target.files.length !== 1) return;

  const reader: FileReader = new FileReader();
  reader.onprogress = (data) => {
    if (data.lengthComputable) {
      this.showSpinner = true;
      this.progressImport = (data.loaded / data.total) * 100;
    }
  };
  reader.onload = (e: any) => {
    this.showSpinner = false;
    const bstr: string = e.target.result;
    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });
    const wsname: string = wb.SheetNames[0];
    const ws: XLSX.WorkSheet = wb.Sheets[wsname];
    const data = XLSX.utils.sheet_to_json(ws, { defval: "" });

    // Validate columns
    const expectedCols = [
      "Voucher_Day",
      "Voucher_Month",
      "Voucher_Year",
      "Payment_Day",
      "Payment_Month",
      "Payment_Year",
      "Loan_No",
      "HeadId",
      "Amount",
      "Narration"
    ];
    if (
      data.length === 0 ||
      Object.keys(data[0]).toString() !== expectedCols.toString()
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Format Mismatch or Empty Spreadsheet!",
        ...this.configSuccess,
      })._dismissAfter(1000);
      return;
    }

    // Add VoucherDate and PaymentDate fields
    data.forEach((x: any) => {
      x.VoucherDate = `${x.Voucher_Month}/${x.Voucher_Day}/${x.Voucher_Year}`;
      x.PaymentDate = `${x.Payment_Month}/${x.Payment_Day}/${x.Payment_Year}`;
    });

    this.mode = "indeterminate";
    this.progressImport = 100;
    this.showSpinner = true;
console.log("Sending to API:", JSON.stringify(data));
    // Call your API for processing (replace with your actual API)
    this.lmsService.LMS_Payment_Loan_Import_Data({
      JSON: JSON.stringify(data),
      LoginUserId: this.currentUser.userId,
    }).subscribe((res: any) => {
      this.showSpinner = false;
      if (res[0].CODE == 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].Msg,
          ...this.configSuccess,
        });
      } else {
        this.displayedColumnsBulkImport = [
          "VoucherDate",
          "PaymentDate",
          "Loan_No",
          "HeadId",
          "Amount",
          "Narration"
        ];
        this.displayedColumnsNotMatchImport = [
          "VoucherDate",
          "PaymentDate",
          "Loan_No",
          "HeadId",
          "Amount",
          "Narration",
          "NotMach"
        ];
        const ImportData = JSON.parse(JSON.stringify(res));
        this.Matchhdata = ImportData.filter((x: any) => x.Status == 1);
        this.MisMatchdata = ImportData.filter((x: any) => x.Status == 0);
        this.dataSourceBulkImport = new MatTableDataSource(this.Matchhdata);
        this.dataSourceBulkImport_NotMatch = new MatTableDataSource(this.MisMatchdata);
      }
    });
  };
  reader.readAsArrayBuffer(target.files[0]);
  event.target.value = "";
}

onAccountingFileChange(event: any) {
  const target: DataTransfer = <DataTransfer>(event.target);
  if (target.files.length !== 1) return;

  const reader: FileReader = new FileReader();
  reader.onload = (e: any) => {
    const arrayBuffer: ArrayBuffer = e.target.result;
  const uint8Array = new Uint8Array(arrayBuffer);
  const binaryString = Array.from(uint8Array, byte => String.fromCharCode(byte)).join('');
  const wb: XLSX.WorkBook = XLSX.read(binaryString, { type: "binary" });
    const data = XLSX.utils.sheet_to_json(wb, { defval: "" });
    this.uploadedAccountingData = data;
    // Use the template column order
    this.uploadedAccountingColumns = [
      "Voucher_Day",
      "Voucher_Month",
      "Voucher_Year",
      "Payment_Day",
      "Payment_Month",
      "Payment_Year",
      "AccountId",
      "Amount",
      "Narration"
    ];
    this.uploadedAccountingDataSource = new MatTableDataSource(data);
  };
  reader.readAsArrayBuffer(target.files[0]);
}
}
